<template>
    <div class="dg-detail">
        <ConfirmDialog />
        <div class="dg-detail__header">
            <h4 class="p-m-0">
                <i class="pi pi-cog p-mr-2" />Hisense
            </h4>
            <small class="p-text-secondary">
                Integração com o webservice Hisense
            </small>
        </div>
        <TabView>
            <TabPanel header="Detalhes">
                <div class="p-fluid p-formgrid p-grid">
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                    id="service_order_id"
                    name="service_order_id"
                    type="text"
                    v-model="serviceOrder.service_order_id"
                    :disabled="true"
                />
                <label for="service_order_id">Referência</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="service_order_no"
                name="service_order_no"
                type="text"
                v-model="serviceOrder.service_order_no"
                :disabled="true"
                />
                <label for="service_order_no">Nº Ordem de Serviço</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="pat_id"
                name="pat_id"
                type="text"
                v-model="serviceOrder.pat_id"
                :disabled="true"
                />
                <label for="pat_id">Pat</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="problem"
                name="problem"
                type="text"
                v-model="serviceOrder.problem"
                :disabled="true"
                />
                <label for="problem">Problema</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="order_type"
                name="order_type"
                type="text"
                v-model="serviceOrder.order_type"
                :disabled="true"
                />
                <label for="order_type">Tipo da Ordem de Serviço</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="order_status"
                name="order_status"
                type="text"
                v-model="serviceOrder.order_status"
                :disabled="true"
                />
                <label for="order_status">Estado da Ordem de Serviço</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="created_user"
                name="created_user"
                type="text"
                v-model="serviceOrder.created_user"
                :disabled="true"
                />
                <label for="created_user">Criado por</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="created_date"
                name="created_date"
                type="text"
                v-model="serviceOrder.created_date"
                :disabled="true"
                />
                <label for="created_date">Data da Criação</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="assign_date"
                name="assign_date"
                type="text"
                v-model="serviceOrder.assign_date"
                :disabled="true"
                />
                <label for="assign_date">Data de Atribuição</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="reservation_date"
                name="reservation_date"
                type="text"
                v-model="serviceOrder.reservation_date"
                :disabled="true"
                />
                <label for="reservation_date">Data de Recepção</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="warranty_type"
                name="warranty_type"
                type="text"
                v-model="serviceOrder.warranty_type"
                :disabled="true"
                />
                <label for="warranty_type">Tipo de Garantia</label>
            </span>
            </div>
            <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="repair_note"
                name="repair_note"
                type="text"
                v-model="serviceOrder.repair_note"
                :disabled="true"
                />
                <label for="repair_note">Nota do problema</label>
            </span>
            </div>
            <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <Textarea
                id="repair_note"
                name="repair_note"
                type="text"
                :autorezie="true"
                v-model="serviceOrder.repair_note"
                :disabled="true"
                />
                <label for="repair_note">Nota de Reparação</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="product_id"
                name="product_id"
                type="text"
                v-model="serviceOrder.product_id"
                :disabled="true"
                />
                <label for="product_id">Id do Produto</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_model"
                name="customer_model"
                type="text"
                v-model="serviceOrder.customer_model"
                :disabled="true"
                />
                <label for="customer_model">Modelo do Produto</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="serial_number"
                name="serial_number"
                type="text"
                v-model="serviceOrder.serial_number"
                :disabled="true"
                />
                <label for="serial_number">Serial Number</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="external_reference"
                name="external_reference"
                type="text"
                v-model="serviceOrder.external_reference"
                :disabled="true"
                />
                <label for="external_reference">Referência Externa</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="purchase_date"
                name="purchase_date"
                type="text"
                v-model="serviceOrder.purchase_date"
                :disabled="true"
                />
                <label for="purchase_date">Data da Compra</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_first_name"
                name="customer_first_name"
                type="text"
                v-model="serviceOrder.customer_first_name"
                :disabled="true"
                />
                <label for="customer_first_name">Cliente Nome</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_last_name"
                name="customer_last_name"
                type="text"
                v-model="serviceOrder.customer_last_name"
                :disabled="true"
                />
                <label for="customer_last_name">Cliente Apelido</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_telephone"
                name="customer_telephone"
                type="text"
                v-model="serviceOrder.customer_telephone"
                :disabled="true"
                />
                <label for="customer_telephone">Cliente Telefone</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_mobil_phone"
                name="customer_mobil_phone"
                type="text"
                v-model="serviceOrder.customer_mobil_phone"
                :disabled="true"
                />
                <label for="customer_mobil_phone">Cliente Telemóvel</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_email"
                name="customer_email"
                type="text"
                v-model="serviceOrder.customer_email"
                :disabled="true"
                />
                <label for="customer_email">Cliente Email</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_address_1"
                name="customer_address_1"
                type="text"
                v-model="serviceOrder.customer_address_1"
                :disabled="true"
                />
                <label for="customer_address_1">Cliente Morada 1</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_address_2"
                name="customer_address_2"
                type="text"
                v-model="serviceOrder.customer_address_2"
                :disabled="true"
                />
                <label for="customer_address_2">Cliente Morada 2</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_address_3"
                name="customer_address_3"
                type="text"
                v-model="serviceOrder.customer_address_3"
                :disabled="true"
                />
                <label for="customer_address_3">Cliente Morada 3</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_zip_code"
                name="customer_zip_code"
                type="text"
                v-model="serviceOrder.customer_zip_code"
                :disabled="true"
                />
                <label for="customer_zip_code">Cliente Código Postal</label>
            </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
                <InputText
                id="customer_city"
                name="customer_city"
                type="text"
                v-model="serviceOrder.customer_city"
                :disabled="true"
                />
                <label for="customer_city">Cliente Localidade</label>
            </span>
            </div>
                </div>
            </TabPanel>

            <TabPanel
                v-if="canShowCloseForm"
                header="Reparação Hisense"
            >
                <Fieldset
                    v-if="canShowCloseForm"
                    legend="Dados de Fecho"
                    class="hisense-fieldset"
                    :toggleable="false"
                >
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_service_type">Tipo de Serviço</label>
                            <Dropdown
                                id="close_service_type"
                                v-model="closeForm.service_type"
                                :options="serviceTypes"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_service_status">Estado do Serviço</label>
                            <Dropdown
                                id="close_service_status"
                                v-model="closeForm.service_status"
                                :options="serviceStatuses"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                                :filter="true"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_in_progress">Em processo</label>
                            <Dropdown
                                id="close_in_progress"
                                v-model="closeForm.in_progress"
                                :options="inProgressStatuses"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                                :filter="true"
                            />
                        </div>

                        <div class="p-field p-col-12 p-md-3" v-if="closeForm.service_status === 'E0014'">
                            <label for="close_repair_date">Data de Reparação</label>
                            <Calendar
                                id="close_repair_date"
                                v-model="closeForm.repair_date"
                                dateFormat="yy-mm-dd"
                                :showIcon="true"
                                :manualInput="true"
                            />
                        </div>
                    </div>

                    <h5 class="hisense-subtitle">Informação adicional</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_repair_note">Problema demonstrado</label>
                            <Textarea
                                id="close_repair_note"
                                v-model="closeForm.repair_note"
                            />
                        </div>
                    </div>

                    <h5 class="hisense-subtitle">Equipamento</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_equipment_model">Modelo</label>
                            <InputText
                                id="close_equipment_model"
                                v-model="closeForm.equipment_model"
                                :maxlength="40"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_equipment_serial_number">Número de série</label>
                            <InputText
                                id="close_equipment_serial_number"
                                v-model="closeForm.equipment_serial_number"
                                :maxlength="30"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_software_version">Versão de Software</label>
                            <InputText
                                id="close_software_version"
                                v-model="closeForm.software_version"
                                :maxlength="40"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_purchase_date">Data de Compra</label>
                            <Calendar
                                id="close_purchase_date"
                                v-model="closeForm.purchase_date"
                                dateFormat="yy-mm-dd"
                                :showIcon="true"
                                :manualInput="true"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="close_warranty_type">Tipo de Garantia</label>
                            <Dropdown
                                id="close_warranty_type"
                                v-model="closeForm.warranty_type"
                                :options="warrantyTypes"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                            />
                        </div>
                    </div>

                    <h5 class="hisense-subtitle">Códigos de Diagnóstico</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_code_group">Grupo de Produto <span class="hisense-required">*</span></label>
                            <Dropdown
                                id="close_code_group"
                                v-model="closeForm.code_group"
                                :options="codeGroups"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar grupo"
                                :showClear="true"
                                :filter="true"
                                @change="onCodeGroupChange"
                            />
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_symptoms_code">Cód. Sintoma</label>
                            <Dropdown
                                id="close_symptoms_code"
                                v-model="closeForm.symptoms_code"
                                :options="symptomCodeOptions"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                                :filter="true"
                                :disabled="!closeForm.code_group"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_defect_code">Cód. Defeito</label>
                            <Dropdown
                                id="close_defect_code"
                                v-model="closeForm.defect_code"
                                :options="defectCodeOptions"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                                :filter="true"
                                :disabled="!closeForm.code_group"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="close_repair_code">Cód. Reparação</label>
                            <Dropdown
                                id="close_repair_code"
                                v-model="closeForm.repair_code"
                                :options="repairCodeOptions"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="Seleccionar"
                                :showClear="true"
                                :filter="true"
                                :disabled="!closeForm.code_group"
                            />
                        </div>
                    </div>

                    <h5 class="hisense-subtitle">Custos</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                            <label for="close_other_fee">Outros impostos (€)</label>
                            <InputNumber
                                id="close_other_fee"
                                v-model="closeForm.other_fee"
                                mode="decimal"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="close_distance">Distância (km)</label>
                            <InputNumber
                                id="close_distance"
                                v-model="closeForm.distance"
                                mode="decimal"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                            />
                        </div>
                    </div>

                    <div class="hisense-actions">
                        <Button
                            v-if="!isClosed"
                            label="Atualizar Reparação"
                            icon="pi pi-check-circle"
                            class="p-button-success"
                            :loading="loading"
                            @click="confirmClose"
                        />
                    </div>
                </Fieldset>
            </TabPanel>

            <TabPanel
                v-if="false"
                header="Pedido de Peças"
            >
                <Fieldset
                    legend="Novo pedido (SetSalesOrder INTERFACE_03)"
                    class="hisense-fieldset"
                    :toggleable="true"
                >
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                            <label for="parts_order_type">Tipo de Encomenda <span class="hisense-required">*</span></label>
                            <Dropdown
                                id="parts_order_type"
                                v-model="partsForm.order_type"
                                :options="partsOrderTypes"
                                optionLabel="label"
                                optionValue="code"
                                placeholder="ZSO2"
                            />
                        </div>
                        <div class="p-field p-col-12 p-md-9">
                            <label for="parts_problem_des">Descrição da encomenda <span class="hisense-required">*</span></label>
                            <InputText id="parts_problem_des" v-model="partsForm.problem_des" maxlength="40" />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="parts_ship_to_id">Ship To ID <span class="hisense-required">*</span></label>
                            <InputText id="parts_ship_to_id" v-model="partsForm.ship_to_id" maxlength="10" />
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <label for="parts_ship_to_name">Nome destino</label>
                            <InputText id="parts_ship_to_name" v-model="partsForm.ship_to_name" maxlength="40" />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="parts_ship_to_country">País</label>
                            <InputText id="parts_ship_to_country" v-model="partsForm.ship_to_country" maxlength="3" />
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <label for="parts_ship_to_address1">Morada</label>
                            <InputText id="parts_ship_to_address1" v-model="partsForm.ship_to_address1" maxlength="30" />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="parts_ship_to_city">Localidade</label>
                            <InputText id="parts_ship_to_city" v-model="partsForm.ship_to_city" maxlength="40" />
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="parts_ship_to_zip">Cód. Postal</label>
                            <InputText id="parts_ship_to_zip" v-model="partsForm.ship_to_zip_code" maxlength="10" />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="parts_ship_to_telephone">Telefone</label>
                            <InputText id="parts_ship_to_telephone" v-model="partsForm.ship_to_telephone" maxlength="40" />
                        </div>
                        <div class="p-field p-col-12 p-md-4">
                            <label for="parts_ship_to_email">Email</label>
                            <InputText id="parts_ship_to_email" v-model="partsForm.ship_to_email" maxlength="100" />
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label for="parts_currency">Moeda</label>
                            <InputText id="parts_currency" v-model="partsForm.currency" maxlength="3" />
                        </div>
                        <div class="p-field p-col-12 p-md-2">
                            <label for="parts_shipment_cost">Custo Envio</label>
                            <InputNumber id="parts_shipment_cost" v-model="partsForm.shipment_cost" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                        </div>
                        <div class="p-field p-col-12">
                            <label for="parts_note">Notas</label>
                            <InputText id="parts_note" v-model="partsForm.note" maxlength="1000" />
                        </div>
                    </div>

                    <h5 class="hisense-subtitle">
                        Artigos
                        <Button
                            icon="pi pi-plus"
                            label="Adicionar"
                            class="p-button-text p-button-sm p-ml-2"
                            @click="addPartsItem"
                        />
                    </h5>

                    <table class="parts-items-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>ID Produto *</th>
                                <th>Descrição</th>
                                <th>Qtd. *</th>
                                <th>Preço unit.</th>
                                <th>Plant</th>
                                <th>Storage</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in partsForm.items" :key="idx">
                                <td>{{ idx + 1 }}</td>
                                <td><InputText v-model="item.product_id" maxlength="40" /></td>
                                    <td><InputText v-model="item.product_des" maxlength="40" /></td>
                                <td><InputNumber v-model="item.quantity" mode="decimal" :minFractionDigits="0" :maxFractionDigits="3" :min="0.001" /></td>
                                <td><InputNumber v-model="item.net_value" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" /></td>
                                <td><InputText v-model="item.plant" maxlength="10" /></td>
                                <td><InputText v-model="item.storage_loc" maxlength="10" /></td>
                                <td>
                                    <Button
                                        icon="pi pi-trash"
                                        class="p-button-text p-button-danger p-button-sm"
                                        :disabled="partsForm.items.length === 1"
                                        @click="removePartsItem(idx)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="hisense-actions">
                        <Button
                            label="Enviar pedido para Hisense"
                            icon="pi pi-send"
                            :loading="partsLoading"
                            @click="confirmPartsRequest"
                        />
                    </div>
                </Fieldset>

                <Fieldset
                    legend="Histórico de pedidos"
                    class="hisense-fieldset p-mt-4"
                    :toggleable="true"
                >
                    <Message v-if="!partsOrders.length" severity="info" :closable="false">
                        Ainda não existem pedidos de peças para esta ordem de serviço.
                    </Message>
                    <div v-for="po in partsOrders" :key="po.id" class="parts-history-card">
                        <div class="parts-history-header">
                            <strong>{{ po.sp_order }}</strong>
                            <span class="p-text-secondary p-ml-2">OBJECT_ID: {{ po.object_id || '—' }}</span>
                            <span class="parts-history-status p-ml-2">{{ po.order_status }}</span>
                            <Button
                                v-if="po.object_id"
                                label="Atualizar estado"
                                icon="pi pi-refresh"
                                class="p-button-text p-button-sm p-ml-auto"
                                :loading="pollingId === po.id"
                                @click="pollPartsOrder(po)"
                            />
                        </div>
                        <div class="p-text-secondary p-mb-2">
                            Tipo: {{ po.order_type }} · Submetido: {{ po.submitted_at || '—' }}
                            · Último poll: {{ po.last_polled_at || '—' }}
                        </div>
                        <table class="parts-items-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Produto</th>
                                    <th>Qtd</th>
                                    <th>Estado</th>
                                    <th>Rejeição</th>
                                    <th>Entrega</th>
                                    <th>Tracking</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="it in po.items" :key="it.id">
                                    <td>{{ it.item_number }}</td>
                                    <td>{{ it.product_id }} <span class="p-text-secondary">{{ it.product_des }}</span></td>
                                    <td>{{ it.quantity }}</td>
                                     <td>{{ formatPartsItemStatus(it.item_status) }}</td>
                                    <td>{{ it.item_reject_code || '—' }}</td>
                                    <td>{{ it.delivery_quantity || '—' }} / {{ it.act_delivery_date || '—' }}</td>
                                    <td>{{ it.tracking_no_to_com || '—' }} {{ it.tracking_no_to || '' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Fieldset>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Fieldset from "primevue/fieldset";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Message from "primevue/message";
import hisenseService from "@/services/hisense.service";
import patService from "@/services/pat.service";
import {
    warrantyTypes,
    serviceTypes,
    delayReasons,
    unsolvedReasons,
    inProgressStatuses,
    serviceStatuses,
    partsOrderTypes,
    partsItemStatuses,
    codeGroups,
    symptomCodes,
    defectCodes,
    repairCodes,
} from "@/helpers/hisenseCatalogs";

export default {
    name: 'PatHisenseDetail',
    components: { TabView, TabPanel, Fieldset, Button, Calendar, InputNumber, Dropdown, Message },
    props: {
        serviceOrder: {
            type: Object,
            required: true
        },
        patId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            patInfo: null,
            loading: false,
            warrantyTypes,
            serviceTypes,
            delayReasons,
            unsolvedReasons,
            serviceStatuses,
            inProgressStatuses,
            partsOrderTypes,
            partsItemStatuses,
            codeGroups,
            partsOrders: [],
            partsLoading: false,
            pollingId: null,
            partsForm: this.buildEmptyPartsForm(),
            closeForm: this.buildEmptyForm(),
        };
    },
    computed: {
        isClosed() {
            return Boolean(
                this.serviceOrder &&
                (this.serviceOrder.order_status === 'E0014' || this.serviceOrder.closed_at)
            );
        },
        canShowCloseForm() {
            if (!this.serviceOrder || !this.serviceOrder.id) {
                return false;
            }
            if (Number(this.serviceOrder.accepted) !== 1) {
                return false;
            }
            if (this.isClosed) {
                return false;
            }
            return this.can('closeHisenseServiceOrder');
        },
        canShowParts() {
            if (!this.serviceOrder || !this.serviceOrder.id) return false;
            if (Number(this.serviceOrder.accepted) !== 1) return false;
            return this.can('viewHisenseSpareParts') || this.can('requestHisenseSpareParts');
        },
        symptomCodeOptions() {
            const cg = this.closeForm.code_group;
            if (!cg || !symptomCodes[cg]) return [];
            return symptomCodes[cg].flatMap((item) => {
                if (item.subCodes && item.subCodes.length) {
                    return item.subCodes.map((sub) => ({
                        code: sub.sCode,
                        label: item.fCode === sub.sCode
                            ? `${sub.sCode} — ${sub.sDes}`
                            : `${item.fCode} / ${sub.sCode} — ${sub.sDes}`,
                    }));
                }

                return [{
                    code: item.fCode,
                    label: `${item.fCode} — ${item.fDes}`,
                }];
            });
        },
        defectCodeOptions() {
            const cg = this.closeForm.code_group;
            if (!cg || !defectCodes[cg]) return [];
            return defectCodes[cg].map((item) => ({
                code: item.code,
                label: `${item.code} — ${item.des}`,
            }));
        },
        repairCodeOptions() {
            const cg = this.closeForm.code_group;
            if (!cg || !repairCodes[cg]) return [];
            return repairCodes[cg].map((item) => ({
                code: item.code,
                label: `${item.code} — ${item.des}`,
            }));
        },
    },
    watch: {
        'serviceOrder.id': {
            immediate: true,
            handler() {
                this.closeForm = this.buildEmptyForm();
                this.partsForm = this.buildEmptyPartsForm();
                this.loadPartsOrders();
            }
        }
    },
    async mounted() {
        await this.loadPatInfo();
    },
    methods: {
        async loadPatInfo() {
            if (!this.patId) return;
            try {
                const response = await patService.getInfo(this.patId);
                this.patInfo = response;

                this.closeForm.equipment_model = this.patInfo.equipment.model || '';
                this.closeForm.equipment_serial_number = this.patInfo.equipment.serie || '';
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro ao carregar informações do PAT',
                    detail: error.message || 'Ocorreu um erro inesperado.',
                    life: 5000,
                });
            }
        },
        buildEmptyForm() {
            return {
                service_type: this.serviceOrder ? (this.serviceOrder.service_type || '') : '',
                service_status: null,
                in_progress: null,
                repair_note: '',
                equipment_model: this.serviceOrder ? (this.serviceOrder.customer_model || '') : '',
                equipment_serial_number: this.serviceOrder ? (this.serviceOrder.serial_number || '') : '',
                software_version: '1',
                purchase_date: this.serviceOrder && this.serviceOrder.purchase_date
                    ? new Date(this.serviceOrder.purchase_date + 'T00:00:00')
                    : null,
                repair_date: this.serviceOrder && this.serviceOrder.repair_date
                    ? new Date(this.serviceOrder.repair_date + 'T00:00:00')
                    : null,
                warranty_type: this.serviceOrder ? (this.serviceOrder.warranty_type || '') : '',
                code_group: this.serviceOrder
                    ? (
                        this.serviceOrder.symptoms_code_g ||
                        this.serviceOrder.defect_code_g ||
                        this.serviceOrder.repair_code_g ||
                        this.serviceOrder.code_group ||
                        null
                    )
                    : null,
                symptoms_code: this.serviceOrder ? (this.serviceOrder.symptoms_code || '') : '',
                defect_code: this.serviceOrder ? (this.serviceOrder.defect_code || '') : '',
                repair_code: this.serviceOrder ? (this.serviceOrder.repair_code || '') : '',
                other_fee: this.serviceOrder ? (parseFloat(this.serviceOrder.other_fee) || null) : null,
                distance: this.serviceOrder ? (parseFloat(this.serviceOrder.distance) || null) : null,
            };
        },
        validateForm() {
            const required = [
               ['service_type', 'Tipo de Serviço'],
               ['service_status', 'Estado do Serviço'],
               ['code_group', 'Grupo de Produto'],
            ];
            const missing = required
               .filter(([key]) => {
                   const value = this.closeForm[key];
                   return value === null || value === undefined || value === '';
               })
               .map(([, label]) => label);

            if (missing.length) {
               this.$toast.add({
                   severity: 'warn',
                   summary: 'Campos obrigatórios',
                   detail: missing.join(', '),
                   life: 5000,
               });
               return false;
            }
            return true;
        },
        onCodeGroupChange() {
            this.closeForm.symptoms_code = '';
            this.closeForm.defect_code = '';
            this.closeForm.repair_code = '';
        },
        formatDate(value) {
            if (!value) {
                return null;
            }
            const date = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(date.getTime())) {
                return null;
            }
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },
        buildPayload() {
            return {
                service_type: this.closeForm.service_type || null,
                service_status: this.closeForm.service_status || null,
                in_progress: this.closeForm.in_progress || null,
                repair_note: this.closeForm.repair_note || null,
                customer_model: this.closeForm.equipment_model || null,
                serial_number: this.closeForm.equipment_serial_number || null,
                software_version: this.closeForm.software_version || null,
                purchase_date: this.formatDate(this.closeForm.purchase_date),
                warranty_type: this.closeForm.warranty_type || null,
                symptoms_code: this.closeForm.symptoms_code || null,
                symptoms_code_g: this.closeForm.code_group || null,
                defect_code: this.closeForm.defect_code || null,
                defect_code_g: this.closeForm.code_group || null,
                repair_code: this.closeForm.repair_code || null,
                repair_code_g: this.closeForm.code_group || null,
                other_fee: this.closeForm.other_fee,
                distance: this.closeForm.distance,
                repair_date: this.closeForm.repair_date ? this.formatDate(this.closeForm.repair_date) : null,
            };
        },
        buildEmptyPartsForm() {
            const storeName = [
                this.serviceOrder ? this.serviceOrder.store_name_1 : '',
                this.serviceOrder ? this.serviceOrder.store_name_2 : '',
            ].filter(Boolean).join(' ').trim();
            const customerName = [
                this.serviceOrder ? this.serviceOrder.customer_first_name : '',
                this.serviceOrder ? this.serviceOrder.customer_last_name : '',
            ].filter(Boolean).join(' ').trim();
            return {
                order_type: 'ZSO2',
                problem_des: '',
                ship_to_id: this.serviceOrder ? (this.serviceOrder.sp_partner || '') : '',
                ship_to_name: storeName || (this.serviceOrder ? (this.serviceOrder.store_contact_person || this.serviceOrder.customer_full_name || customerName) : ''),
                ship_to_address1: this.serviceOrder ? (this.serviceOrder.store_address_1 || this.serviceOrder.customer_address_1 || '') : '',
                ship_to_address2: this.serviceOrder ? (this.serviceOrder.store_address_2 || this.serviceOrder.customer_address_2 || '') : '',
                ship_to_address3: this.serviceOrder ? (this.serviceOrder.store_address_3 || this.serviceOrder.customer_address_3 || '') : '',
                ship_to_city: this.serviceOrder ? (this.serviceOrder.store_city || this.serviceOrder.customer_city || '') : '',
                ship_to_zip_code: this.serviceOrder ? (this.serviceOrder.store_zip_code || this.serviceOrder.customer_zip_code || '') : '',
                ship_to_country: 'PT',
                ship_to_province: this.serviceOrder ? (this.serviceOrder.store_province || this.serviceOrder.customer_province || '') : '',
                ship_to_telephone: this.serviceOrder ? (this.serviceOrder.store_contact_telephone || this.serviceOrder.store_telephone || this.serviceOrder.customer_telephone || '') : '',
                ship_to_cellphone: this.serviceOrder ? (this.serviceOrder.store_contact_mobilphone || this.serviceOrder.customer_mobil_phone || '') : '',
                ship_to_email: this.serviceOrder ? (this.serviceOrder.store_contact_email || this.serviceOrder.store_email || this.serviceOrder.customer_email || '') : '',
                currency: 'EUR',
                shipment_cost: null,
                note: '',
                items: [this.buildEmptyPartsItem()],
            };
        },
        buildEmptyPartsItem() {
            return {
                product_id: '',
                product_des: '',
                quantity: 1,
                net_value: null,
                plant: '',
                storage_loc: '',
            };
        },
        addPartsItem() {
            this.partsForm.items.push(this.buildEmptyPartsItem());
        },
        removePartsItem(idx) {
            if (this.partsForm.items.length > 1) {
                this.partsForm.items.splice(idx, 1);
            }
        },
        async loadPartsOrders() {
            if (!this.serviceOrder || !this.serviceOrder.id) return;
            if (!this.canShowParts) return;
            const response = await hisenseService.listSpareParts(this.serviceOrder.id);
            this.partsOrders = (response && response.orders) || [];
        },
        validatePartsForm() {
            if (!this.partsForm.problem_des) {
                this.$toast.add({ severity: 'warn', summary: 'Campos obrigatórios', detail: 'Descrição da encomenda', life: 4000 });
                return false;
            }
            if (this.partsForm.problem_des.length > 40) {
                this.$toast.add({ severity: 'warn', summary: 'Limite excedido', detail: 'Descrição da encomenda até 40 caracteres', life: 4000 });
                return false;
            }
            if (!this.partsForm.ship_to_id) {
                this.$toast.add({ severity: 'warn', summary: 'Campos obrigatórios', detail: 'Ship To ID', life: 4000 });
                return false;
            }
            const invalid = this.partsForm.items.find((it) => !it.product_id || !it.quantity);
            if (invalid) {
                this.$toast.add({ severity: 'warn', summary: 'Itens incompletos', detail: 'Cada artigo precisa de ID Produto e Quantidade', life: 4000 });
                return false;
            }
            return true;
        },
        formatPartsItemStatus(code) {
            const item = this.partsItemStatuses.find((status) => status.code === code);
            return item ? item.label : code;
        },
        confirmPartsRequest() {
            if (!this.validatePartsForm()) return;
            this.$confirm.require({
                message: `Enviar pedido de ${this.partsForm.items.length} artigo(s) para a Hisense?`,
                header: 'Pedido de Peças',
                icon: 'pi pi-question-circle',
                acceptLabel: 'Sim, enviar',
                rejectLabel: 'Cancelar',
                accept: () => this.submitPartsRequest(),
            });
        },
        async submitPartsRequest() {
            this.partsLoading = true;
            try {
                const payload = {
                    ...this.partsForm,
                    items: this.partsForm.items.map((it) => ({
                        product_id: it.product_id,
                        product_des: it.product_des || null,
                        quantity: it.quantity,
                        net_value: it.net_value,
                        plant: it.plant || null,
                        storage_loc: it.storage_loc || null,
                    })),
                };
                const response = await hisenseService.requestSpareParts(this.serviceOrder.id, payload);
                if (response && response.status === 'OK') {
                    this.$toast.add({ severity: 'success', summary: 'Pedido enviado', detail: `OBJECT_ID: ${response.partsOrder ? response.partsOrder.object_id : ''}`, life: 5000 });
                    this.partsForm = this.buildEmptyPartsForm();
                    await this.loadPartsOrders();
                } else {
                    const detail = (response && (response.error || response.message)) || 'Falhou.';
                    this.$toast.add({ severity: 'error', summary: 'Erro Hisense', detail, life: 7000 });
                }
            } finally {
                this.partsLoading = false;
            }
        },
        async pollPartsOrder(po) {
            this.pollingId = po.id;
            try {
                const response = await hisenseService.pollSparePartsOrder(this.serviceOrder.id, po.id);
                if (response && response.status === 'OK') {
                    this.$toast.add({ severity: 'success', summary: 'Atualizado', detail: `Estado: ${response.partsOrder.order_status}`, life: 4000 });
                    await this.loadPartsOrders();
                } else {
                    const detail = (response && (response.error || response.message)) || 'Falhou.';
                    this.$toast.add({ severity: 'error', summary: 'Erro Hisense', detail, life: 7000 });
                }
            } finally {
                this.pollingId = null;
            }
        },
        confirmClose() {
            if (!this.validateForm()) {
                return;
            }
            this.$confirm.require({
                message: 'Confirma o envio da atualização da ordem de serviço para a Hisense?',
                header: 'Atualizar Reparação',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sim, atualizar',
                rejectLabel: 'Cancelar',
                accept: () => this.submitClose(),
            });
        },
        async submitClose() {
            this.loading = true;
            try {
                const response = await hisenseService.updateServiceOrder(
                    this.serviceOrder.id,
                    this.buildPayload()
                );

                if (response && response.status === 'OK') {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Atualizado',
                        detail: 'Ordem de serviço atualizada na Hisense.',
                        life: 5000,
                    });
                    if (response.serviceOrder) {
                        this.$emit('update:serviceOrder', response.serviceOrder);
                    }
                    this.$emit('refresh');
                } else {
                    const detail =
                        (response && (response.error || response.message)) ||
                        'Não foi possível atualizar a ordem de serviço.';
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro Hisense',
                        detail,
                        life: 7000,
                    });
                }
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.dg-detail {
  &__header {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--surface-border, #dee2e6);

    h3 {
      display: flex;
      align-items: center;
      font-weight: 600;
    }

    small {
      display: block;
      margin-top: 0.25rem;
    }
  }
}

.hisense-fieldset {
  margin-top: 1.5rem;
}

.hisense-subtitle {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.hisense-required {
  color: var(--red-500, #d9534f);
  margin-left: 2px;
}

.hisense-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.hisense-closed-message {
  margin-top: 1.5rem;
}

.parts-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}
.parts-items-table th,
.parts-items-table td {
  border-bottom: 1px solid #e5e7eb;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.9rem;
}
.parts-items-table th {
  text-align: left;
  background: #f9fafb;
}

.parts-history-card {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}
.parts-history-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.parts-history-status {
  background: var(--surface-200, #e5e7eb);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.85rem;
}
</style>
